module.exports = {
  home: {
    welcome: '欢迎来到',
    welcome2: '客户服务平台',
    intro1: "我们是一家拥有",
    year: "多年经验",
    and: "以及",
    people: "众多人才 ",
    intro2: "的激光设备制造机构",
    look: "了解一下我们的",
    bpin: "Bodor+3.0是一个全新激光工业与物联网交互平台，打造激光加工全方位服务新生态",
    web: "WEB端服务",
    webin: "Web端以详尽的功能、大方的页面为您提供各式各样的服务，Bodor+现已更新至第三代，业务广泛，惠及全球",
    app: "移动端APP",
    appin: "Bodor+移动端APP由专业团队设计研发，经过多方调研与分析，囊括数据收集、设备监控等各方各面",
    monitor: "设备监控",
    monitorin: "绑定机床后，24h无间断监控设备数据，确保第一时间为您呈现，可靠的数据传输系统为您的安全保驾护航",
    dc: "数据收集",
    dcin: "为您提供加工时长统计等各项加工数据的同时，还通过各种数据可视化方法为您直观展现",
    area: "的 应用领域",
    machinery: "工程机械",
    advert: "广告标识",
    fitness: "健身器材",
    air: "空调暖通",
    architectural: "建筑装饰",
    car: "汽车制造",
    steel: "钢结构",
    ship: "船舶制造",
    mesin: "BodorMes是由Bodor研发团队自主研发的生产执行智能制造系统，面向个体、中小型、大型、海外加工用户，帮助用户在经营、生产、质量、交付上提高效益使用户的生产更加透明化、可视化、可量化",
    steelstructure: "钢结构行业",
    solution: "解决方案",
    solutionin: "传统的钢结构行业，工程师首先要做的就是拆图、套料、PDM管理工作,进而了解该厂房项目需要的型材件是多少以及生产下料零件的优先级。 同时采购人员做工程预算，需要购买的板材、管材、参数来源于技术工程师提供。 生产车间工程师要考虑是否要估算设备最大加工时效，还要监控生产环节，进行每天工件统计以及设备运行统计等等问题",
    withmes: "而使用BodorMes之后，您可以",
    project: "创建项目合同",
    projectin: "通过图形软件自动拆分各项零部件，自动导入切割系统",
    file: "导出加工文件",
    filein: "使用BodorCAM进行下料管理",
    order: "一键下发产单",
    orderin: "智能计算匹配的生产设备并同步生产单通知到相关人员",
    control: "进度全部掌控",
    controlin: "全方面了解当前厂房加工的进度、设备生产时效等报告",
    increase1: "将为您带来的 ",
    increase2: "增益",
    gain: "所得增益",
    average1: "平均增加",
    average1in1: "加快多部门协作响应",
    average1in2: "提升生产数据完整性",
    average1in3: "提高制造效率和质量",
    purchase: "立即购买",
    download: "软件下载",
    video: "操作视频",
    purchaseinfo: "请致电400-991-7771获取报价",
    coast: "节约成本",
    average2: "平均节省",
    average2in1: "缩短规划和制造周期",
    average2in2: "简化沟通和纸张使用",
    average2in3: "减少在制品滞留数量",
    hubin: "BodorHub是专注于Bodor激光切割设备的信息采集系统",
    acquisition: "数据采集",
    acquisitionin: "支持34种切割参数采集，全面监控切割设备实用信息；支持设备运行日志、报告、运行统计查看导出",
    simple: "简单快捷",
    simplein: "以http协议对接第三方系统，简单快捷，系统可提供对接实例及友好的开发介绍案例",
    instant: "即时查看",
    instantin: "通过websock协议对转速、状态等信息实时推送，设备即时信息随时查看",
    private: "私有部署",
    privatein: "全面支持私有化部署，数据绝对安全可靠",
    hubin2: "在每个Bodor人心中，客户永远是第一位",
    partners1: "我们HUB的 ",
    partners2: "合作伙伴",
    camin: "支持多种行业专用软件，支持功能特殊定制，材料利用率相较旧版本提高15%，排版速度提升25%，10年专业团队助力套料切割无缝衔接。",
    contact1: "有疑问/感兴趣？请随时与 ",
    contact2: "我们联系",
    question: "如果您有任何问题，欢迎随时咨询我们",
    email: "邮箱地址",
    emailin: "请输入您的电子邮箱地址",
    name: "姓名",
    namein: "请输入您的称谓",
    message: "信息",
    submit: "提交",
    copyright: `济南邦德激光股份有限公司©️2024版权所有`,
    login: "登录",
    home: "首页",
    contactus: "联系我们",
    visitor: "游客访问",
    tech: "技术支持",
    techin: "您可以访问我们的知识库或者下载我们的软件，无需登录",
    techHeader: "官方指南",
    techinfo1: "访问知识库，您可以查看到我们的开发人员为您提供的详尽指南，帮助您了解我们的设备、软件与操作",
    techinfo2: "访问软件下载，您可以查看到我们CAM二维与三维切割软件的更新说明、历史版本和环境包，您可以随意进行下载使用，还可以观看我们的官方操作视频",
    techBtn: "现在访问",
    nestin: "(板切)",
    tubein: "(管切)",
    label: "文章标签",
    labelin: "请输入文章标签",
    search: "查询",
    reset: "重置",
    phone: "访问手机端",
    appin2: "若要体验完整功能,请扫描下方二维码使用微信小程序体验",
    appok: '关闭',
    official: "访问官网",
  },
  login: {
    new: "全新升级",
    choose: "为什么选择",
    info1: "登录即可获享BodorNest Tube三维管材套料软件试用",
    info2: "登录并绑定设备，实时监控设备状态，挖掘潜在的问题",
    info3: "登录即可查看数据统计，相关数据随时查询分析",
    noaccount: "没有账号",
    register: "立即注册",
    back: "返回首页",
    login: "登录",
    account: "账户",
    enteraccount: "请输入您的账号",
    enterpassword: "请输入您的密码",
    success: "登录成功",
    accountEmpty: "账号不得为空",
    passwordEmpty: "密码不得为空",
    forget: "忘记密码?",
    resert: "重置密码",
    saveSuccess: "修改成功",
    again: "请重新获取验证码",
    email: "邮箱",
    code: "验证码",
    nPassword: "新密码",
    nPasswordin: "请输入新密码",
    confirm: "确认密码",
    confirmin: "请确认密码",
    noCode: "没收到验证码",
    noCodein: "请联系客服人员协助解决忘记密码问题",
    submit: "提交",
  },
  register: {
    new: "全新升级",
    register: "注册",
    account: "账号",
    password: "密码",
    confirm: "确认密码",
    email: "邮箱",
    name: "姓名",
    phone: "手机",
    address: "地址",
    accountin: "请输入您的账号",
    passwordin: "请输入您的密码",
    confirmin: "请确认密码",
    emailin: "请输入您的邮箱",
    namein: "请输入您的姓名",
    phonein: "请输入您的手机",
    codein: "请输入您的验证码",
    addressin1: "请选择您的国家",
    addressin2: "请选择您的省份",
    addressin3: "请选择您的城市",
    addressin4: "请选择您的区县",
    back: "返回",
    accountEmpty: "账号不得为空",
    passwordEmpty: "密码不得为空",
    confirmEmpty: "两次输入的密码不一致",
    nameEmpty: "姓名不得为空",
    emailEmpty: "邮箱不得为空",
    addressEmpty: "地址不得为空",
    phoneEmpty: "手机不得为空",
    codeEmpty: "验证码不得为空",
    success: "注册成功",
    sucInfo: `若要关联CAM账户,请使用注册手机号登录本网站后前往"个人中心"绑定邮箱并使用邮箱登录CAM`,
    emailError: "请输入正确的邮箱格式",
    phoneError: "请输入正确的手机号格式",
    emailDuplicate: "邮箱已被注册",
    code: "手机验证",
    emailcode: "邮箱验证",
    getCode: "获取验证码",
    codeErr: "验证码错误！",
    wait: "后可获取",
    subSuc: "提交成功",
    subInfo: "您的信息已提交，请联系客服人员人工注册",
    noCode: "未收到验证码",
    submit: "提交",
    noCodein: "若您未收到验证码，请在勾选该选项后直接点击提交按钮提交人工审核，否则请取消勾选正常填写验证码进行注册"
  },
  index: {
    user: "个人中心",
    myDevice: "我的设备",
    task: "我的任务",
    software: "软件下载",
    cam: "CAM软件",
    knowledge: "知识库",
    use: "用机知识",
    devicein: "在这里您可以看到自己所绑定的设备，点击类型可以筛选对应的设备，点击设备可以进入查看设备详情，点击添加新设备可以绑定新的设备",
    screen: "按照类型筛选",
    all: "所有类型",
    add: "添加新设备",
    order: "订单编号",
    orderin: "请输入订单编号",
    bind: "立即绑定",
    bindError: "新的设备编号不得为空！",
    bindSuccess: "绑定成功！",
    report: "加工报告",
    reportin: "在这里您可以看到自己加工任务的报告",
    reporttb1: "任务名称",
    reporttb2: "切割长度",
    reporttb3: "空移长度",
    reporttb4: "开始时间",
    reporttb5: "结束时间",
    reporttb6: "文件名称",
    reporttb7: "穿孔个数",
    reporttb8: "加工用时",
    time: "加工时长",
    timein: "在这里您可以看到自己加工时长的列表",
    timetb1: "运行时长",
    timetb2: "空闲时长",
    timetb3: "离线时长",
    timetb4: "创建时间",
    timetb5: "急停时长",
    statistics: "加工统计",
    statisticsin: "在这里您可以看到自己加工任务数量以及告警的统计",
    statisticsChart1: "任务数量周统计",
    statisticsChart2: "告警数量周统计",
    selectWeek: "请选择统计周",
    softwarein: "在这里您可以下载我们的软件",
    downloadNavi: "下载导航",
    downloadInfo: "了解详情",
    downloadWc: "小程序端",
    downloadTube: "切割行业的三维套料软件",
    downloadNest: "切割行业的平面套料软件",
    back: "返回",
    plusHeader1: "专属",
    plusHeader2: "定制",
    plusHeader3: "完美",
    plusHeader4: "匹配",
    plusSlide: "下滑查看更多内容",
    softwarePackage: "软件包",
    download: "下载",
    updateInfo: "更新日志",
    EnvirPackage: "环境包",
    video: "视频教程",
    video1: "软件登录与使用流程",
    video2: "创建任务及导入",
    video3: "一键设置",
    video4: "自动排样",
    video5: "手动排样",
    video6: "自动排序",
    video7: "手工排序",
    video8: "排样-工艺-排序",
    video9: "编辑共边刀路",
    video10: "余料",
    video11: "骨架切碎",
    video12: "报告单",
    video13: "导出NC",
    video14: "自动微连",
    video15: "外部批量导入",
    effect: "作用",
    effect1: "软件运行必需环境",
    camin: "在这里您可以查看CAM软件的授权情况",
    resources: "相关资源",
    downloadInfo2: "点击左侧下载图标即可下载软件",
    softwareName: "软件名称",
    softwareAuthor: "软件类型",
    newVersion: "最新版本",
    updateTime: "更新时间",
    right1: "版本对比",
    right2: "环境包",
    right3: "历史版本",
    right4: "视频教程",
    right5: "说明书",
    launch: "点击展开/折叠文章概述",
    myCam: "我的软件授权",
    exchange: "积分兑换",
    exchangetb1: "标题",
    exchangetb2: "原价",
    exchangetb3: "现价",
    exchangetb4: "优惠",
    exchangetb5: "操作",
    exchangebtn: "兑换",
    camWarn: "请先登录CAM账户",
    accountConfirm: "工号验证",
    name: "姓名",
    namein: "请输入您的姓名",
    account: "工号",
    accountin: "请输入您的工号",
    camInfo1: "许可编码",
    camInfo2: "产品名",
    camInfo3: "许可开始时间",
    camInfo4: "许可结束时间",
    camInfo5: "许可有效截止时间",
    camInfo6: "许可首次使用时间",
    camInfo7: "最后在线时间",
    camInfo8: "最后在线版本",
    look: "查看",
    knowledgetb1: "标题",
    knowledgetb2: "标签",
    knowledgetb3: "语言",
    knowledgetb4: "创建时间",
    knowledgetb5: "操作",
    knowledgetb6: "系列",
    deviceInfo: "设备详情",
    deviceMonitor: "设备监控",
    workTime: "加工时长",
    workWeek: "时长周统",
    realTime: "实时数据",
    repair: "设备报修",
    repairin: "在这里您可以选择自主报修或者咨询客服",
    workInfo: "任务详情",
    selectDay: "请选择统计日",
    workedTime: "已加工时长",
    deviceName: "设备单号",
    deviceType: "设备类型",
    deviceStatus: "设备状态",
    deviceTask: "当前任务",
    run: "运行",
    idle: "空闲",
    offline: "离线",
    stop: "急停",
    sheet: "板材切割机",
    tube: "管材切割机",
    runInfo: "加工中……",
    idleInfo: "加工未开始",
    offlineInfo: "设备离线中",
    stopInfo: "设备急停",
    x: "x轴",
    y: "y轴",
    z: "z轴",
    w: "w轴",
    speed: "速度",
    power: "功率",
    pressure: "气压",
    contact: "联系方式",
    contactin: "请输入您的联系方式",
    reson: "报修原因",
    resonin: "请输入您的报修原因",
    submit: "提交",
    cancel: "取消",
    jobErr: "提交失败，请检查用户名或者工号是否为空!",
    jobSuccess: "验证成功!",
    exchangeSuccess: "兑换成功!",
    left: "剩余进度",
    cutLength: "切割长度",
    emptyLength: "空移长度",
    percent: "给进倍率",
    number: "零件数量",
    wsState1: "设备空闲",
    wsState2: "加工开始中",
    wsState3: "设备运行",
    wsState4: "设备暂停中",
    wsState5: "设备暂停",
    wsState6: "设备停止中",
    wsState7: "设备急停中",
    wsState8: "设备急停",
    wsState9: "设备离线",
    device: "设备",
    height: "高度",
    voltage: "电压",
    startTime: "加工开始时间",
    endTime: "加工结束时间",
    cutTime: "切割时间",
    emptyTime: "空移时间",
    hole: "穿孔数",
    holeTime: "穿孔时间",
    logOut: "退出登录",
    view: "浏览量",
    videoin: `如果遇到无法全屏的情况，请右击视频，选择"在新建标签页中打开视频"`,
    videoList: "视频列表",
    maintenance: "设备保养",
    maintenancein: "在这里您可以查看设备保养信息并进行保养设备",
    maintenance1: "保养项目",
    maintenance1info: "点击表格左侧复选框可以给对应的设备绑定保养项目,再次点击可以取消该设备绑定的保养项目",
    maintenance2: "维护保养",
    downloadCenter: "下载中心",
    autoQuery: "输入内容自动查询",
    queryTree: "请输入目录名称",
    noEmail: "邮箱尚未绑定",
    noEmailin: "开通Cam账户需要绑定邮箱,是否前往个人中心绑定?",
    notNow: "以后再说",
    emailNow: "前往绑定",
    file: "加工文件",
    official: "访问官网",
    pierceCount: "穿孔个数",
    pierceDuration: "穿孔时间",
    partCount: "目前已加工零件个数",
  },
  user: {
    aboutMe: "关于我的",
    basicInfo: "基本信息",
    account: "账号",
    phone: "手机",
    name: "姓名",
    mail: "邮箱",
    address: "地址",
    oldPass: "旧密码",
    newPass: "新密码",
    confirmPass: "确认密码",
    passwordIn: "如果不需要修改密码请不填",
    device: "拥有设备",
    save: "保存修改",
    nameErr: "姓名不可为空!",
    phoneErr: "手机号格式错误!",
    oldErr: "旧密码不可为空!",
    newErr: "两次输入的密码不一致!",
    vip: "会员成长等级",
    toGrowth: "去提升会员等级",
    level1: "普通会员",
    level2: "白银会员",
    level3: "黄金会员",
    level4: "白金会员",
    level5: "钻石会员",
    gValue: "成长值",
    next1: "距离下一等级还需",
    next2: "分",
    warranty: "质保信息",
    orderin: "请输入订单编号",
    search: "查询",
    reset: "重置",
    getdeviceerr: "获取用户设备失败!",
    orderNumber: "设备编号",
    deliveryTime: "发货日期",
    marketingDept: "营销部门",
    belongDept: "所属部门",
    laserBrand: "激光器品牌",
    extdWarrantyTime: "延保时间",
    guaranteeTime: "保修周期",
    isGuarantee: "是否在保",
    extdWarrantyType: "延保类型",
    changeEmail: "绑定/更换邮箱",
    question: "问题反馈",
    questionin: "请输入反馈标题",
    questionTitle: "反馈标题",
    product: "所属产品",
    version: "版本号",
    person: "反馈人",
    contact: "联系方式",
    time: "提交日期",
    processingStatus: "处理状态",
    isComplaint: "加急状态",
    newQuestion: '反馈提交',
    action: "操作",
    complaint: "加急",
    urgent: "急单",
    noUrgent: "不加急",
    progress: "处理中",
    completed: "已处理",
    ended: "已结束",
    urgented: "已加急",
    urgentsucc: "加急成功,工程师将收到加急提醒并为您优先处理",
    check: "查看",
    questionTitle: "反馈详情",
    want: "预计处理时间",
    reality: "实际处理时间",
    step: "重现步骤",
    file: "文件",
    code: "邮箱验证",
  },
  uk: {
    random: "随机文件",
    guide: "操作指南",
    download: "下载中心",
    common: "常见故障",
    wait: "敬请期待",
  },
  visitor: {
    back: "返回首页",
  },
  repair: {
    online: "在线咨询",
    common: "自助检修",
    click: "一键报修",
    repairtb1: "标题",
    repairtb2: "标签",
    repairtb3: "操作",
  },
  click: {
    work: "工单提报",
    order: "订单号",
    devicein: "请选择您的设备",
    suberr: "请检查格式错误并重新提交",
    phone: "手机号",
    phonein: "请输入您的手机号",
    phoneerr: "请输入正确格式的手机号",
    email: "邮箱",
    emailin: "请输入您的邮箱",
    emailerr:"请输入正确格式的邮箱",
    company: "公司",
    companyin: "请输入您的公司",
    province: "省份",
    provincein: "请选择您的省份",
    city: "城市",
    cityin: "请选择您的城市",
    content: "内容",
    contentin: "请输入您的提报内容",
    notnow: "存草稿",
    submit: "提交",
    event: "工单编号",
    eventin: "请输入工单编号",
    search: "查询",
    resert: "重置",
    newevent: "提报工单",
    status1: "处理中",
    status2: "已完成",
    status3: "待处理",
    createTime: "创建时间",
    look: "查看",
    detail: "工单详情",
    basic: "基础信息",
    eventNum: "工单号",
    ownOrder: "所属订单",
    ownUser: "提报人",
    ownCopany: "提报公司",
    ownTime: "提报时间",
    ownEmail: "提报邮箱",
    ownAddress: "提报省市",
    Owncontent: "工单描述",
    status: "工单状态",
    des1: "待分配工程师或等待工程师处理",
    des2: "工程师将为您处理工单",
    des3: "工单已处理完毕",
    action: "操作",
    success: "提报成功!",
    successin: "本次工单号为：",
    worker: "服务与评价",
    evaluate: "评价工程师",
    spareTitle:"故障类型", 
    spareContent:"请选择备件",
    inventoryTitle:"备件库存", 
    inventoryContent:"请输入备件库存",
    stock:"备件库存",
    spareCode:"备件编码",
    spareName:"备件名称",
    specs:"规格",
    size:"尺寸",
    Threshold:"库存阈值",
    edit:"编辑"
  },
  main: {
    title1: "保养详情",
    project: "保养项目",
    orderNumber: "设备单号",
    realName: "人员姓名",
    content: "保养内容",
    label: "保养标签",
    cycle: "保养周期(时)",
    surplus: "到期时间(时)",
    createTime: "创建日期",
    warningHours: "提前预警(时)",
    warningTime: "预警时间",
    isEnabled: "是否启用",
    isNormal: "保养状态",
    confirm: "确认保养",
    title2: "保养记录",
    disabled: "遭禁用",
    enabled: "已启用",
    overdue: "过期",
    normal: "正常",
    maintain: "保养",
    action: "操作",
    name: "保养人",
    time: "保养日期",
    yes: "是",
    no: "否",
    pleaseSelect: "请选择保养日期!",
  },
  service: {
    center: "服务中心",
    policy: "服务政策",
    standards: "服务标准",
    verify: "验证登录",
    account: "工号",
    accountin: "请输入您的工号!",
    password: "密码",
    passwordin: "请输入您的密码!",
    submit: "提交",
    orderNumber: "订单编号",
    orderin: "请输入订单编号!",
    search: "查询",
    reset: "重置",
    deviceName: "设备名称",
    deviceSeries: "设备系列",
    deviceModel: "设备系列",
    language: "语言",
    version: "版本号",
    operation: "操作",
    view: "查看",
    deviceInfo: "设备信息",
    randomFile: "随机文件",
    download: "下载",
    power: "额定功率",
    voltage: "额定电压",
    current: "满载电流",
    shortCircuit: "短路额定值",
    frequency: "频率",
    date: "生产日期",
    warranty: "质保期天数",
    encryption: "加密",
    remarks: "备注",
    fileName: "文件名称",
    machineType: "整机类型",
    cuttingMachine: "切割机整机",
    weldingMachine: "焊接机整机",
    fileType: "文件分类",
    success: "验证成功!",
    error: "非邦德员工!",
    noData: "暂无数据",
  },
  camReport: {
    camReport: "CAM问题反馈",
    product: "所属产品",
    productin: "请输入所属产品",
    version: "版本号",
    versionin: "请输入版本号",
    name: "反馈人",
    namein: "请输入您的称谓",
    phone: "联系方式",
    phonein: "请输入联系方式",
    title: "问题标题",
    titlein: "请输入问题标题",
    step: "重现步骤",
    stepin: "请输入重现步骤",
    bnt: "bnt文件",
    bntin: "请上传bnt文件",
    bnn: "bnn文件",
    bnnin: "请上传bnn文件",
    other: "igs/stp文件",
    otherin: "请上传igs/stp文件",
    other2: "dxf/dwg文件",
    otherin2: "请上传dxf/dwg文件",
    submit: "提交",
    error: "网址错误",
    errorin: "请返回CAM软件重新跳转链接",
    success: "提交成功",
    successin: "您可以使用提交时填写的手机号注册Bodor+账户查看处理状态并进行加急操作",
    registerUrl: "注册网址: ",
    app: "或扫描下方二维码使用微信小程序体验",
    nosupport: "不支持上传该类型文件",
    uploadsucc: "上传成功",
    uploaderror: "上传失败",
    import: "导入",
    exTime: "期望处理时间",
    exTimein: "请选择预计处理完成时间",
    phoneerr: "请输入正确格式的手机号或者邮箱",
  },
  userReport: {
    userReport: "Bodor+问题反馈",
    product: "所属产品",
    productin: "请选择所属产品",
    version: "版本号",
    versionin: "请输入版本号",
    name: "反馈人",
    namein: "请输入您的称谓",
    phone: "联系方式",
    phonein: "请输入联系方式",
    title: "问题标题",
    titlein: "请输入问题标题",
    step: "重现步骤",
    stepin: "请输入重现步骤",
    bnt: "bnt文件",
    bntin: "请上传bnt文件",
    bnn: "bnn/bnd文件",
    bnnin: "请上传bnn/bnd文件",
    other: "igs/stp文件",
    otherin: "请上传igs/stp文件",
    other2: "dxf/dwg文件",
    otherin2: "请上传dxf/dwg文件",
    another: "附件",
    anotherin: "请上传其他文件",
    submit: "提交",
    error: "信息错误",
    errorin: "请返回Bodor+重新登录",
    success: "提交成功",
    successin: "您可以在个人中心页面查看已提交反馈处理进度或进行加急操作",
    registerUrl: "注册网址: ",
    app: "也可以扫描下方二维码使用微信小程序体验同等内容",
    nosupport: "不支持上传该类型文件",
    uploadsucc: "上传成功",
    uploaderror: "上传失败",
    import: "导入",
    exTime: "期望处理时间",
    exTimein: "请选择预计处理完成时间",
    phoneerr: "请输入正确格式的手机号或者邮箱",
  },
  file: {
    orderNumber: "设备编号",
    fileName: "文件名称",
    createTime: "创建时间",
    title: "工业文件云推送",
    titlein: "可以在此处推送您的工业文件,安全快捷可靠便利",
    upload: "点击上传",
    drawerTitle1: "上传新文件",
    selectFile: "选择文件",
    delete: "删除",
    deletein: "确定删除此文件?",
    uFile: "上传文件",
    uploadBox: "点击或拖拽新的文件到此处",
    close: "关闭",
    submit: "上传",
    submitError: "文件名含有+等特殊字符,请修改文件名后重新上传!",
    success: "上传成功!",
    fail: "上传失败!",
    fail1: "获取设备工业文件接口请求失败!原因:",
    fail2: "获取用户设备列表接口请求失败!原因:",
    faile3: "删除工业文件接口请求失败!原因:",
    faile4: "获取加工报告接口请求失败!原因:",
    faile5: "获取CAM加工报告接口请求失败!原因:",
    searchErr: "请输入文件名称!",
    search: "输入文件名称检索工业文件",
    workReport: "加工记录",
    processType: "加工类型",
    thickness: "管材厚度",
    partCount: "零件数量",
    pierceCount: "穿孔个数",
    pierceDuration: "穿孔时间(ms)",
    PerforationTime: "穿孔时间(s)",
    idleLength: "空移长度(m)",
    idleTime: "空移时间(s)",
    slicingLength: "切割长度(m)",
    slicingDuration: "切割时间(ms)",
    cutTime: "切割时间(s)",
    totalDuration: "加工时间(ms)",
    processingTime: "加工时间(s)",
    startTime: "加工开始时间",
    endTime: "加工结束时间",
    useTubeCount: "使用管材数量",
    isComplete: "是否完成",
    fileName: "加工文件",
    completed: "已完成",
    notCompleted: "未完成",
    process: "加工",
    emptyOperation: "空运行",
    machineName: "设备名称",
    createTime: "创建时间",
    camReport: "CAM报告",
    camReportSheet1: "CAM板材信息(板机)",
    camReportSheet2: "CAM零件信息(板机)",
    Material: "材质",
    TaskName: "任务名称",
    PlateSize: "板材尺寸",
    Thickness: "厚度",
    Density: "密度",
    PlateCount: "板材数量(张)",
    PlateWeight: "板材重量(Kg)",
    PlateName: "板材名称",
    UtilizationRate: "利用率",
    NestName: "排样名称",
    camReportTube1: "CAM报告(管机)",
    camReportTube2: "CAM排样信息(管机)",
    camReportTube3: "CAM零件信息(管机)",
    camReportTube4: "CAM管材信息(管机)",
    ProjectName: "项目名称",
    CreateTime: "创建日期",
    Gap: "管材留边(mm)",
    CutLength: "截断距离(mm)",
    Material2: "材料",
    TubeInfo: "管材信息",
    TubeThickness: "管材厚度(mm)",
    SectionInfo: "规格",
    SectionType: "管材类型",
    Code: "单零件编码",
    Name: "单零件名称",
    Size: "单零件尺寸",
    Count: "单零件数量",
    Weight: "单零件重量(g)",
    LayoutQuantity: "排样数量",
    SurPlusQuantity: "零件剩余数量",
    PartCutLength: "单零件切割长度(m)",
    ID: "ID",
    NestTubeID: "管件ID",
    Sort: "排样序号",
    SortName: "排样管材名称",
    Length: "管材总长",
    SurplusLength: "剩余长度",
    UsedTubeCount: "使用管材数量",
    Count2: "数量",
    CutLength2: "切割总长",
    AirLength: "空移长度",
    PerforationCount: "穿孔次数",
    Sort2: "零件序号",
    Name2: "零件名称",
    Size2: "零件尺寸",
    Weight2: "零件重量",
    Count3: "零件总数",
    UsedCount: "零件排样数量",
    SurplusCount: "零件剩余数量",
    Name3: "管材名称",
    Sort3: "管材序号",
    Section: "管材截面",
    Length2: "管材长度",
    Count4: "管材总数",
    UsedCount2: "管材用量",
    SurplusCount2: "管材剩余",
    img: "零件略缩图",
    sheetImg: "板材缩略图",
    downloadReport: "下载文件",
  },
  information:{
    new: "全新升级",
    title:"信息采集",
    register:"提交",
    people:"联系人",
    peoplein:"请输入联系人姓名",
    peopleEmpty: "联系人不得为空",
    email:"邮箱",
    emailEmpty:"邮箱不得为空",
    emailError: "请输入正确的邮箱格式",
    company:"公司名称",
    companyin:"请输入公司名称",
    companyEmpty:"公司名称不得为空",
    address:"地址",
    addressin:"请输入地址",
    addressEmpty:"地址不得为空",
  }
}